import * as identify from "utils/treeUtils";
import type { NodeApi } from "@hogartrabe/react-arborist-vrh";
import type { AnyFolder } from "interfaces/schemas";

export const getLocalPath = (
  node: NodeApi | null,
  path: string = "",
): string => {
  if (!node) {
    return path;
  }
  const { data }: { data: AnyFolder } = node;
  if (identify.isRoot(data)) {
    return `${data.folderName} / ${path}`;
  }
  if (path === "") {
    return getLocalPath(node.parent, `${data.folderName}`);
  }
  return getLocalPath(node.parent, `${data.folderName} / ${path}`);
};
